// extracted by mini-css-extract-plugin
module.exports = {"is-preload":"styles-module--is-preload--4WtZN","title":"styles-module--title--2UIbU","question":"styles-module--question--24FiE","answer":"styles-module--answer--3vOYF"};